module.exports = __webpack_public_path__ + "static/media/1_citrus_cupcake.02924d4e.jpg";